// eslint-disable-next-line operator-linebreak
export const { REACT_APP_ENV, REACT_APP_API_BASE_URL } = process.env;
export const API_BASE_URL = REACT_APP_API_BASE_URL || "http://localhost:8000";
